import { GraphQLClient } from "graphql-request";
import { AxiosRequestConfig } from 'axios';

import { requestConfig } from './request-config';
import init, { Response } from './request-wrapper';

export const API_URL = 'https://app.ollieapp.travel:2020/api/v2/hbmc';
type Options = {
  url?: string;
};

const apiService = (options: Options): GraphQLClient => {
  const client = new GraphQLClient(`${API_URL}${options.url}`, {headers:{
    Accept: 'application/json'
  }});

 return client;
};

const BASE_URL = 'https://app.ollieapp.travel:2020/api/v2/hbmc';

const apiServiceRest = <TRequest, TResponse = TRequest>(
  config?: AxiosRequestConfig
): [Response<TRequest, TResponse>, AxiosRequestConfig] => {
  const newConfig = requestConfig({
    baseURL: BASE_URL,
    headers: {
      Accept: 'application/json',
      ...config?.headers
    },
    responseType: config?.responseType ? config?.responseType : undefined
  });
  return [init(newConfig), newConfig];
};

export { apiService, apiServiceRest };
